module.exports = __webpack_public_path__ + "img/checkedSkeleton.4967afff.png";